import React, { useEffect, useRef, useState } from 'react';
import { JSBarCodeGenerator } from '../lib';
import { QRCodeGenerator } from '../lib/QRBarCodeGenerator';
import { SNUBH_ICON, TOOGGLES } from '../consts';

export const Body = ({ hspId, barcodeValue, ptNo, barcodeType, barcodeDefaultType, hspLogoImageUrl }) => {
  const [curBarcodeType, setCurBarcodeType] = useState(barcodeDefaultType);
  const toogleRefs = useRef([]);

  useEffect(() => {
    if (barcodeType === 'ALL') {
      if (curBarcodeType === 'QR') {
        toogleRefs.current[TOOGGLES.QR].className = 'active';
        toogleRefs.current[TOOGGLES.BARCODE].classList.remove('active');
      } else {
        toogleRefs.current[TOOGGLES.BARCODE].className = 'active';
        toogleRefs.current[TOOGGLES.QR].classList.remove('active');
      }
    }
  }, [curBarcodeType, barcodeType]);

  const qrBarcodeGenerator = () => {
    let qrBarcodes = [];

    if (curBarcodeType === 'BARCODE') {
      const BARCODE_COUNT = 5;
      const format = barcodeType === 'ALL' ? 'CODE128' : barcodeType;
      for (let i = 0; i < BARCODE_COUNT; i++) {
        qrBarcodes.push(<JSBarCodeGenerator key={`barcode-${i}`} text={barcodeValue} format={format} />);
      }
    }

    if (curBarcodeType === 'QR') {
      qrBarcodes.push(<QRCodeGenerator key='qr-l' text={barcodeValue} style={{ width: 200, margin: 0 }} />);
      qrBarcodes.push(<QRCodeGenerator key='qr-s' text={barcodeValue} style={{ width: 120, margin: 0 }} />);
    }

    return qrBarcodes;
  };

  return (
    <div className='pt-card-wrap'>
      <div className='pt-card-barcode-wrap' style={{ gap: curBarcodeType === 'QR' ? '20px' : '2px' }}>
        {qrBarcodeGenerator()}
      </div>
      <div className='pt-card-text-section'>
        <span className='pt-card-title'>등록 번호</span>
        <span className='pt-card-value'>{ptNo}</span>
      </div>

      {barcodeType === 'ALL' && (
        <div className='code-tab'>
          <ul className='code-tab-wrap'>
            <li
              ref={(el) => (toogleRefs.current[TOOGGLES.QR] = el)}
              onClick={() => {
                setCurBarcodeType('QR');
              }}
            >
              <span>QR코드</span>
            </li>
            <li
              ref={(el) => (toogleRefs.current[TOOGGLES.BARCODE] = el)}
              onClick={() => {
                setCurBarcodeType('BARCODE');
              }}
            >
              <span>바코드</span>
            </li>
          </ul>
        </div>
      )}

      <div className='pt-card-info'>
        <span>
          무인수납기에서 환자카드 바코드를 스캔하여
          <br />
          사용하실 수 있어요.
        </span>
      </div>

      <div className='pt-card-logo-wrap'>
        <img src={hspId === '7' ? SNUBH_ICON : hspLogoImageUrl} alt='병원로고' className='pt-card-logo' />
      </div>
    </div>
  );
};
